import * as React from "react";
export class PlaceholderBtn extends React.PureComponent {
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons" },
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-text" }),
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-odd" })),
            React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons" },
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-text" }),
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-odd" })),
            React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons" },
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-text" }),
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-odd" })),
            React.createElement("div", { className: "rj-ev-list__placeholder__empty-element" })));
    }
}
//# sourceMappingURL=PlaceholderBtn.js.map